<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
      </div>
      <div class="flex-fill overflow-auto">
        <ViewHeader :title="attentionTypesConfig.title" />
        <div class="text--secondary px-4 mb-3">
          {{ attentionTypesConfig.description }}
        </div>
        <v-list>
          <template>
            <div v-for="(option, index) of attentionTypesConfig.options" :key="`option-${index}`">
              <v-list-item
                @click="optionAction(option)"
                :disabled="directCallDisabled && option.id === 1 || option.id === 2 && isListEventCalendar"
                :three-line="!!option.description"
              >
                <v-list-item-icon>
                  <Icon
                    v-if="option.icon"
                    :size="25"
                    :icon="option.icon"
                    :color="directCallDisabled && option.id === 1 || option.id === 2 && isListEventCalendar ? '#A6ACAF' : 'primary'"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ option.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="option.description"
                    style="line-height: 1.5;"
                  >
                    {{ directCallDisabled && option.id === 1 ? $t('messages.cammer.available') : isListEventCalendar && option.id === 2 ? $t('messages.calendar.available') : option.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                :key="`divider-${index}`"
                v-if="(index + 1) < attentionTypesConfig.options.length"
              ></v-divider>
            </div>
          </template>
        </v-list>
        <div v-if="directCallDisabled && $organization.contactCenter()" class="mx-5 mt-5">
          <ContactRequestForm />
        </div>
        <div class="px-5 py-2 text-center">
          <div v-html="attentionTypesConfig.information"></div>
        </div>
        <section id="full-screen-modal">
          <ChannelSelector
            ref="channel-selector"
            :attentionType="selected"
            @selectedChannel="selectedChannel"
          />
        </section>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'
import { mapActions } from 'vuex'

require('@/services/Calendar')

@Component({
  components: {
    ContactRequestForm: () => import(/* webpackPrefetch: true */ '@/views/lobby/components/contact-request/Form.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    ChannelSelector: () => import(/* webpackPrefetch: true */ '@/views/attention-types/components/ChannelSelector.vue')
  },
  computed: {
    organizationId () {
      return this.$store.state.widget.data.organization.id
    },
    attentionTypesConfig () {
      return this.$organization.attentionTypesConfig().data
    },
    cammerAvailableGroupByCategory () {
      return this.$store.state.organization.cammerAvailableGroupByCategory
    },
    category () {
      return this.$store.state.storage.category
    },
    directCallDisabled () {
      const { isActive, data } = this.$organization.detectCammerAvailability()

      let disabled = false

      if (isActive && data?.attentionTypes === 'true') {
        const categoryId = this.category && this.category.uuid ? this.category.id : null

        if (categoryId) {
          const categoryGroup = this.cammerAvailableGroupByCategory.find((item) => item.categoryId === categoryId)
          disabled = !categoryGroup
        } else {
          disabled = !this.cammerAvailableGroupByCategory.length
        }
      }

      return disabled
    },
    isListEventCalendar () {
      return this.$store.state.calendar.events.list.length === 0
    },
    formIsMain () {
      return this.$organization.formIsMain()
    }
  },
  methods: {
    ...mapActions({
      setAttentionChannel: 'setAttentionChannel'
    })
  }
})
export default class Index extends Vue {
  data () {
    return {
      selected: null
    }
  }

  mounted () {
    this.getEvents()
    this.ocGoogleAnalyticsInit();
  }

  getEvents () {
    const activeDate = new Date()

    this.$store.state.calendar.events.list = []

    const params = {
      month: (`0${activeDate.getMonth() + 1}`).slice(-2),
      year: activeDate.getFullYear(),
      timeZone: this.$widget.getDevice().timeZone
    }

    if (this.$store.state.storage.category) {
      params.categoryId = this.$store.state.storage.category.id
    }

    this.$calendar.getAvailableDates(params)
  }

  saveAnalitycsEvent (selected) {
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: `Seleccionó: ${selected}`,
      detail: `El cliente seleccionó el tipo de atención: ${selected}`,
      actionType: 'STAH',
      functionality: 3,
      historyInteractionType: 'OSIFDV'
    })
  }

  goTo (path) {
    if (path === '/calendar') {
      this.saveAnalitycsEvent('Agendar una videollamada')
      this.ocGoogleAnalyticsScheduleVideoCall()
    } else if (path === '/permissions') {
      this.saveAnalitycsEvent('Videollamada inmediata')
      this.ocGoogleAnalyticsImmediateVideoCall()
    }

    setTimeout(() => {
      this.$router.replace({
        path: !this.formIsMain.isActive ? 'home' : path,
        query: { nextPath: !this.formIsMain.isActive ? path : null }
      }).catch((error) => {})
    }, 150)
  }

  selectedChannel (channel) {
    if (this.selected?.id === 1 && channel === 'chat') {
      this.goTo('/calling')
      return
    }

    this.goTo(this.selected.to)
  }

  optionAction (option) {
    // TODO: Mejorar la condición para cuando tenga un solo canal
    this.selected = option

    if (this.selected.channels.length === 1) {
      const channel = this.selected.channels[0]
      this.setAttentionChannel(channel)
      this.selectedChannel(channel)
      // this.goTo(channel === 'chat' ? 'calling' : this.selected.to)
      // return
    } else if (this.selected.channels.length > 1) {
      this.$refs['channel-selector'].show()
    }
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  ocGoogleAnalyticsImmediateVideoCall () {
    OcGoogleAnalytics.getDataLayerConfig('immediate.video.call')
  }

  ocGoogleAnalyticsScheduleVideoCall () {
    OcGoogleAnalytics.getDataLayerConfig('schedule.video.call')
  }
}
</script>

<style scoped>
.v-list-item__subtitle, .v-list-item__title {
  white-space: normal !important;
  line-height: 1.4 !important;
}
</style>
